module.exports = __webpack_public_path__ + "img/pt_n.a0e68633.svg";